import { Box, Chip, IconButton, TableCell, TableRow, Tooltip } from "@mui/material"
import Iconify from "minimals-template/components/Iconify"
import { If, Else } from "lib/@components/switch"

export function LanguageStatRow({ item, onClearCache, onRemove }) {
    return (
        <TableRow>
            <TableCell>
                <Box sx={{ fontWeight: 600 }}>{item.name}</Box>
                <Box sx={{ color: "text.secondary", fontSize: 12 }}>{item.nativeName || item.code}</Box>
            </TableCell>
            <TableCell>{item.code}</TableCell>
            <TableCell>
                <If value={item.rtl}>
                    <Chip label="RTL" size="small" variant="outlined" />
                </If>
            </TableCell>
            <TableCell align="right">{item.cachedSchedules}</TableCell>
            <TableCell align="center">
                <If value={item.skillsTranslated}>
                    <Iconify icon="mdi:check-circle" sx={{ color: "success.main", fontSize: 20 }} />
                    <Else>
                        <Iconify icon="mdi:minus-circle-outline" sx={{ color: "text.disabled", fontSize: 20 }} />
                    </Else>
                </If>
            </TableCell>
            <TableCell align="right">
                <Tooltip title={`Clear translation cache for ${item.name}`}>
                    <IconButton size="small" onClick={handleClearCache}>
                        <Iconify icon="mdi:trash-can-outline" sx={{ fontSize: 18 }} />
                    </IconButton>
                </Tooltip>
                <Tooltip title={`Remove ${item.name}`}>
                    <IconButton size="small" onClick={handleRemove} sx={{ ml: 0.5 }}>
                        <Iconify icon="mdi:close-circle-outline" sx={{ fontSize: 18, color: "error.main" }} />
                    </IconButton>
                </Tooltip>
            </TableCell>
        </TableRow>
    )

    function handleClearCache() {
        onClearCache(item)
    }

    function handleRemove() {
        onRemove(item)
    }
}
